<template>
  <div
    v-for="level1 in levelOneCount"
    :key="level1"
    class="tw-flex tw-items-center tw-space-x-4 tw-py-1 tw-animate-pulse"
    data-testid="tree-menu-loading-state"
  >
    <div class="tw-flex-1 tw-py-2">
      <div class="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"></div>
    </div>
  </div>
  <div
    v-for="level2 in levelTwoCount"
    :key="level2"
    class="tw-p-4 tw-max-w-sm tw-mx-auto"
  >
    <div class="tw-flex tw-items-center tw-space-x-4 tw-animate-pulse">
      <div class="tw-w-4 tw-h-4 tw-rounded tw-bg-gray-200"></div>
      <div class="tw-flex-1 tw-py-1">
        <div class="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"></div>
      </div>
    </div>

    <div v-for="level3 in levelThreeCount" :key="level3" class="tw-ml-6">
      <div
        class="tw-flex tw-items-center tw-space-x-4 tw-animate-pulse tw-mt-2"
      >
        <div class="tw-w-4 tw-h-4 tw-rounded tw-bg-gray-200"></div>
        <div class="tw-flex-1 tw-py-1">
          <div class="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-5/6"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  levelOneCount: number
  levelTwoCount: number
  levelThreeCount: number
}
withDefaults(defineProps<Props>(), {
  levelOneCount: 0,
  levelTwoCount: 0,
  levelThreeCount: 0,
})
</script>
